var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('span',{class:{ '.active' : _vm.isSidebarActive },on:{"click":function($event){$event.preventDefault();return _vm.sideBarToggle($event)}}},[_c('font-awesome-icon',{attrs:{"icon":"id-card"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }